(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select', (event) => {
    let detailsEl = event.target.querySelector('details');

    if (detailsEl instanceof HTMLDetailsElement && detailsEl.matches('.details-block')) {
      detailsEl.open = true;
    }
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    let detailsEl = event.target.querySelector('details');

    if (detailsEl instanceof HTMLDetailsElement && detailsEl.matches('.details-block')) {
      detailsEl.open = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
